import { isEmptyVal } from '@/utils';
import { checkMRSChange } from '@/utils/validator';
import { translation } from '@/plugins/i18n';
import { MRS_STATUS_TYPE_MAP, planTypes } from '@/common/constants';
import { dateTimeFormat } from '@/utils/dateformat.js';
import { get } from 'lodash';
import store from '@/store/index';
import { pageConfig } from '@/common/service/page-config';
import { $context } from '@/global-install';

const PLAN_TYPES_LICENSE_UNIT = [
  planTypes.CONCURRENT_MEETING_BASIC,
  planTypes.TRANSLATION_CAPTIONS
];

const DOWNSELL_MSG_MAP = {
  user: {
    with_date: 'billing.error.downgrade_alert_info',
    without_date: 'billing.error.downgrade_alert_info_no_date'
  },
  license: {
    with_date: 'billing.error.downgrade_alert_info_license',
    without_date: 'billing.error.downgrade_alert_info_no_date_license'
  },
  plan_change: {
    with_date: 'billing.error.downgrade_alert_info_in_plan_change',
    without_date: 'billing.error.downgrade_alert_info_no_date'
  },
};

export const getDownSellLicenseDesc = ({oldPlan, nextPlan, quantity, assignLicenseQuantity, planExpireTime}) => {
  const getters = store.getters;
  const defaultResult = { errorState: 'info', errorMessage: '' };
  if (getters.basicConfig.isBulkLicenseAccount) {
    return defaultResult;
  }

  if (!isEmptyVal(quantity) && quantity < assignLicenseQuantity) {
    const needAssignQuantity = assignLicenseQuantity - quantity;
    const mrsResult = checkMRSChange({
      oldPlan,
      nextPlan,
      nextPlanQuantity: quantity,
    });

    if (mrsResult === MRS_STATUS_TYPE_MAP.CHANGE_NOW) {
      return defaultResult;
    }

    const wordingI18nMap = $context.is.zs2ze ? DOWNSELL_MSG_MAP.plan_change : PLAN_TYPES_LICENSE_UNIT.includes(oldPlan.type) ? DOWNSELL_MSG_MAP.license : DOWNSELL_MSG_MAP.user;
    return {
      assignLicenseQuantity,
      needAssignQuantity,
      planExpireTime,
      errorState: 'info',
      errorMessage: planExpireTime
        ? translation(wordingI18nMap.with_date, [needAssignQuantity, dateTimeFormat(planExpireTime)])
        : translation(wordingI18nMap.without_date, [needAssignQuantity]),
    };
  }

  return defaultResult;
};

export const validDownSellLicense = (planInfo = {}) => {
  const getters = store.getters;
  const { quantity = 0 } = planInfo;
  const { assignLicenseQuantity = 0, planExpireTime } = get(getters.assignInfo, pageConfig.oldPlanCode, {});
  return getDownSellLicenseDesc({
    oldPlan: getters.currentEditPlan,
    nextPlan: get(getters.getSelectedPlans, '[0]', {}),
    quantity,
    assignLicenseQuantity,
    planExpireTime
  });
};

export const validDownSellLicenseForBizPlus = (planInfo = {}) => {
  const getters = store.getters;
  const { quantity = 0, planCode } = planInfo;
  const { assignLicenseQuantity = 0, planExpireTime } = get(getters.assignInfo, planCode, {});
  const oldPlan = getters.boughtPlans.find(p => p.plan_code === planCode);
  const nextPlan = getters.getSelectedPlans.find(p => p.plan_code === planCode);
  return getDownSellLicenseDesc({
    oldPlan,
    nextPlan,
    quantity,
    assignLicenseQuantity,
    planExpireTime
  });
};
